/**
 * @module views\mdl\material
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Watch } from "vue-property-decorator";
import { TreeNode } from "element-ui/types/tree";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import MaterialTypeNavigation from "@/businessComponents/mdl/materialTypeNavigation/materialTypeNavigation";

@Component({
  components: {
    MaterialTypeNavigation
  }
})
export default class Index extends GhBase {
  private draw = true;
  private activatedTab = 0;
  private mini = true;

  private curentMaterialType: IndexObject = {};
  private tabs: IGhTab[] = [
    { title: "物料类型维护", drawer: true, mini: false },
    {
      title: "物料维护",
      drawer: false,
      show: true
    }
  ];

  private argsQueryType = { parent_id: "", keyword: "" };

  @Watch("curentMaterialType")
  private updateArgs() {
    if (this.curentMaterialType && this.curentMaterialType.key) {
      this.argsQueryType.parent_id = this.curentMaterialType.key;
      if (this.table) {
        this.table.query(this.argsQueryType);
      }
    }
  }

  private get table() {
    return this.$refs.table as GhTablePage;
  }

  private beforeSave(item: IndexObject) {
    item.ParentId = this.argsQueryType.parent_id;
  }
}
